import request from '@/utils/request'
import { menuCodeHeaders, ScheduleMenuCode } from '@/utils/menuCodeHeaders'
import {
  GetCapacityDaySummaryRes,
  GetCapacityDayReq,
  GetCapacityDaySummaryReq,
  SetCapacityDayDeltaReq,
  SetCapacityDayReq,
  GetCapacityDayRes,
} from './types'

// 수용량 API 는 gi27·gi28 이 같이 부른다 — 감사 로그 화면코드를 헤더로 보낸다(LOGISPRD-15645)
/** 날짜별-센터별 capa와 활성화 조회합니다. */
export const getCapacityDaySummary = (params: GetCapacityDaySummaryReq, menuCode: ScheduleMenuCode) =>
  request.post<ApiResponseV2<GetCapacityDaySummaryRes>, GetCapacityDaySummaryReq>(
    '/api/v1/get-warehouse-capacity-day-summaries',
    params,
    menuCodeHeaders(menuCode),
  )

/** 날짜별-센터별 제한 여부와 기준 capa를 조회합니다. */
export const getCapacityDay = (params: GetCapacityDayReq, menuCode: ScheduleMenuCode) =>
  request.post<ApiResponseV2<GetCapacityDayRes>, GetCapacityDayReq>('/api/v1/get-warehouse-capacity-day', params, menuCodeHeaders(menuCode))

/** 날짜별-센터별 제한 여부와 기준 capa를 수정합니다. */
export const setCapacityDay = (params: SetCapacityDayReq, menuCode: ScheduleMenuCode) =>
  request.post('/api/v1/set-warehouse-capacity-day', params, menuCodeHeaders(menuCode))

/** 날짜별-센터별 capa를 증차감 합니다. */
export const setCapacityDayDelta = (params: SetCapacityDayDeltaReq, menuCode: ScheduleMenuCode) =>
  request.post('/api/v1/add-warehouse-capacity-day-delta', params, menuCodeHeaders(menuCode))
